import React, { useMemo } from 'react';
import { rem } from 'design-system';
import { IconCoins } from 'design-system/icons/IconCoins';
import { IconBox, IconCart, IconCuttery, IconFavorite, IconHat, IconHeartBeat, IconLightBulb, IconMenuBold, IconMine, IconPhone, IconSettingsBold, IconTechnology, IconTool, IconTools, IconTvBold, IconWheel, } from 'design-system/icons';
import { IconDots } from 'design-system/icons/IconDots';
import { IconHomeAlt } from 'design-system/icons/IconHomeAlt';
import useColors from 'hooks/useColors';
const useSectors = () => {
    const colors = useColors();
    const sectorInfoMap = useMemo(() => {
        const iconSize = rem(24);
        return {
            Finance: {
                gradientKey: 'pro',
                color: colors.gradients.pro,
                Icon: (props) => <IconCoins alt gradientKey="pro" height={iconSize} width={iconSize} {...props}/>,
            },
            Health: {
                gradientKey: 'deepPink',
                color: colors.gradients.deepPink,
                Icon: (props) => <IconHeartBeat gradientKey="deepPink" {...props}/>,
            },
            Tech: {
                gradientKey: 'darkPurple',
                color: colors.gradients.darkPurple,
                Icon: (props) => <IconTechnology gradientKey="darkPurple" {...props}/>,
            },
            Industrials: {
                gradientKey: 'pro',
                color: colors.gradients.pro,
                Icon: (props) => <IconTool gradientKey="pro" {...props}/>,
            },
            Energy: {
                gradientKey: 'yellow',
                color: colors.gradients.yellow,
                Icon: (props) => <IconLightBulb alt gradientKey="yellow" {...props}/>,
            },
            'Consumer Goods': {
                gradientKey: 'apricot',
                color: colors.gradients.apricot,
                Icon: (props) => <IconCart alt gradientKey="apricot" {...props}/>,
            },
            Property: {
                gradientKey: 'orange',
                color: colors.gradients.orange,
                Icon: (props) => <IconHomeAlt gradientKey="orange" {...props}/>,
            },
            Services: {
                gradientKey: 'lightPurple',
                color: colors.gradients.lightPurple,
                Icon: (props) => <IconSettingsBold gradientKey="lightPurple" {...props}/>,
            },
            Mining: {
                gradientKey: 'apricot',
                color: colors.gradients.apricot,
                Icon: (props) => <IconMine gradientKey="apricot" {...props}/>,
            },
            Entertainment: {
                gradientKey: 'ultimate',
                color: colors.gradients.ultimate,
                Icon: (props) => <IconTvBold gradientKey="ultimate" {...props}/>,
            },
            'Food & Drink': {
                gradientKey: 'peach',
                color: colors.gradients.peach,
                Icon: (props) => <IconCuttery gradientKey="peach" {...props} width={iconSize} height={iconSize}/>,
            },
            Cars: {
                gradientKey: 'apricot',
                color: colors.gradients.apricot,
                Icon: (props) => <IconWheel gradientKey="apricot" {...props}/>,
            },
            Logistics: {
                gradientKey: 'lightPurple',
                color: colors.gradients.lightPurple,
                Icon: (props) => <IconBox gradientKey="lightPurple" {...props}/>,
            },
            Construction: {
                gradientKey: 'orange',
                color: colors.gradients.orange,
                Icon: (props) => <IconTools gradientKey="orange" {...props}/>,
            },
            Telco: {
                gradientKey: 'skyBlue',
                color: colors.gradients.skyBlue,
                Icon: (props) => <IconPhone gradientKey="skyBlue" {...props}/>,
            },
            Utilities: {
                gradientKey: 'darkPurple',
                color: colors.gradients.darkPurple,
                Icon: (props) => <IconMenuBold gradientKey="darkPurple" {...props}/>,
            },
            Travel: {
                gradientKey: 'pro',
                color: colors.gradients.pro,
                Icon: (props) => <IconFavorite gradientKey="pro" {...props}/>,
            },
            Fashion: {
                gradientKey: 'ultimate',
                color: colors.gradients.ultimate,
                Icon: (props) => <IconHat gradientKey="ultimate" {...props}/>,
            },
            Others: {
                gradientKey: 'darkPurple',
                color: colors.gradients.darkPurple,
                Icon: (props) => <IconDots gradientKey="darkPurple" {...props}/>,
            },
        };
    }, [colors]);
    return { sectorInfoMap };
};
export default useSectors;
